import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { HeroBannerSectionProps } from '../../../components/sections/HeroBannerSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { HeroBannerSectionContent } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<HeroBannerSectionProps> = dynamic<HeroBannerSectionProps>(
  () =>
    import('../../../components/sections/HeroBannerSection').then((mod) => mod.HeroBannerSection),
);

/* istanbul ignore next */
export const transformer: Transformer<HeroBannerSectionContent, HeroBannerSectionProps> = (
  {
    _metadata,
    background_color,
    text_color_mode,
    image,
    heading,
    sub_heading,
    copy,
    button,
    tracking_title,
  },
  { pageConfig, positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    backgroundColor: background_color,
    headingIsPageTitle: positionMetadata.position === 0 && pageConfig.pageType !== 'homepage',
    images: getContentstackImagesForWidths(image.image_source.url, [360, 500, 700, 900, 1132], {
      aspectRatio: '16:9',
    }),
    imageWidth: 360,
    imageHeight: 216,
    imageAlt: image.alt_text,
    textColorMode: text_color_mode,
    headingLine1: heading.line1,
    headingLine2: heading.line2,
    ...(heading.underline.show_underline && {
      headingUnderlineColor: heading.underline.underline_color,
    }),
    subHeading: sub_heading || '',
    copy: copy || '',
    buttonBackgroundColor: button?.background_color || '',
    buttonHref: button?.url || '',
    buttonText: button?.text || '',
    buttonTextColorMode: button?.text_color || 'light',
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
